import React from "react";
import styles from "./adVisitedLabel.scss";

const AdVisitedLabel = ({ isMobile }) => (
  <span className={isMobile ? styles.visitedLabelMobile : styles.visitedLabel}>
    {"POGLEDANO"}
  </span>
);

export default AdVisitedLabel;



// WEBPACK FOOTER //
// ./src/components/AdCard/AdVisitedLabel/AdVisitedLabel.tsx